import Button from '@components/Button'
import ButtonWithLoader from '@components/ButtonWithLoader'
import Divider from '@components/Divider'
import Heading from '@components/Heading'
import {
    BUTTON_SIZE,
  BUTTON_TYPE,
  COLORS,
  DIVIDER_SIZE,
  HEADING_TYPE,
  TEXT_SIZES,
} from '@helpers/constants'
import { closeLastPanel } from '@state/actions/panelsActions'
import { AppContext } from '@state/context'
import React, { useContext } from 'react'

const EditExerciseWrapper = (props) => {
  const {
    children,
    type,
    onSave
  } = props
  const [state, dispatch] = useContext(AppContext)
  const {
    isLoading,
    isDirty,
  } = state?.exercises ?? {}

  return (
    <>
      <div className={'flex justify-between'}>
        <Heading headingLevel={HEADING_TYPE.H2} size={TEXT_SIZES.MEDIUM}>
          {type}
        </Heading>

        <Button
          iconRight
          handleClick={() => dispatch(closeLastPanel())}
          size={BUTTON_SIZE.NO_PADDING}
          icon={'Close'}
        ></Button>
      </div>
      <Divider size={DIVIDER_SIZE.SMALL} />

      {children && children}

      <div className={'flex justify-center'}>
        <Divider size={DIVIDER_SIZE.SMALL} />
        <ButtonWithLoader
          type={BUTTON_TYPE.PRIMARY}
          isLoading={isLoading}
          disabledText={'Sparat'}
          enabledText={'Spara övning'}
          disabled={!isDirty}
          handleClick={onSave}
        />
        <Divider size={DIVIDER_SIZE.SMALL} />
      </div>
    </>
  )
}

export default EditExerciseWrapper

